import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type PrinterId = Branded<string, "PrinterId">;
const printerIdPrefix = "printer__";
const {
    factory: printerIdFactory,
    assert: isPrinterId,
    zodSchema: printerIdZodSchema,
} = genericId<PrinterId>(printerIdPrefix, {
    regexMatch: /(^printer_.*$)/,
});

export { isPrinterId, printerIdFactory, printerIdPrefix, printerIdZodSchema };
export type { PrinterId };
